import {PlugType} from '../../../stek/cutting-jobs/plug-type.enum';

export class CreateStockWithProductionJob {
  originalAmount: number;
  location: string;
  remarks: string;
  productionJobId: number;
  productionDate: Date;
  inputMaterialAmountUsed: number;
  inputMaterialTrashedAmount: number;
  bookAutomaticallyFromStock: boolean;
  targetUnitSizeId: number;
  materialUnitSizeId: number;
  plugType: PlugType;

  constructor(originalAmount: number, location: string, remarks: string, productionJobId: number,
              productionDate: Date, inputMaterialAmountUsed: number, inputMaterialTrashedAmount: number,
              bookAutomaticallyFromStock: boolean, targetUnitSizeId: number, materialUnitSizeId: number,
              plugType?: PlugType) {
    this.originalAmount = originalAmount;
    this.location = location;
    this.remarks = remarks;
    this.productionJobId = productionJobId;
    this.productionDate = productionDate;
    this.inputMaterialAmountUsed = inputMaterialAmountUsed;
    this.inputMaterialTrashedAmount = inputMaterialTrashedAmount;
    this.bookAutomaticallyFromStock = bookAutomaticallyFromStock;
    this.targetUnitSizeId = targetUnitSizeId;
    this.materialUnitSizeId = materialUnitSizeId;
    this.plugType = plugType;
  }
}
